import { v4 as uuid } from 'uuid';

interface IAlphaResult {
    base64: string;
    /** 作为md5计算的随机数 */
    forceMd5: string;
}
// 预览滤镜的base64结果
const alphaResult: Map<string, IAlphaResult> = new Map();

export const setAlphaResult = (id: string, url: string) => {
    if (!url) {
        alphaResult.delete(id);
    } else {
        alphaResult.set(id, {
            base64: url,
            forceMd5: uuid(),
        });
    }
};

export const fetchAlphaResult = (id: string) => {
    return (
        alphaResult.get(id) || {
            base64: '',
            forceMd5: uuid(),
        }
    );
};
